import { useState } from 'react';
import {HashRouter, Routes, Route, Outlet } from 'react-router-dom';

// import { LoginPage } from './Start/LogIn/LoginPage.jsx';
import  LoginPage  from './Start/LogIn/logIn.js';
import { Bootstrap } from './Start/bootstrap/Bootstrap.jsx';
import { authService } from './core/auth/authService.js';

/**
 * App.jsx
 *
 * The smallest possible root: it only decides "do we have a session
 * or not". If yes, everything is delegated to <Bootstrap>. App.jsx
 * itself never looks at `session.system` — that's Bootstrap's job.
 */
export default function App() {
  const [session, setSession] = useState(() => authService.getSession());

  if (!session) {
    return <LoginPage onLoginSuccess={setSession} />;
    // return (
    //   <HashRouter>
    //     <Routes>
    //         <Route path="/" exact element={<LoginPage onLoginSuccess={setSession} />} />
    //         <Route path="/a" exact element={<>Sign up </>} />
    //     </Routes>
    //   </HashRouter> );
  }

  return <Bootstrap session={session} onLogout={() => setSession(null)} />;
}
